module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-holder performance"
  }, [_c('div', {
    staticClass: "data-holder-inner"
  }, [_c('div', {
    staticClass: "filter-holder row"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.initialized) ? _c('div', {
    staticClass: "filter"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "type": "daterange",
      "align": "left",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "range-separator": "-",
      "start-placeholder": "Start date",
      "end-placeholder": "End date",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dates),
      callback: function($$v) {
        _vm.dates = $$v
      },
      expression: "dates"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.initialized && _vm.dates && _vm.dates[0]) ? _c('i', {
    staticClass: "el-icon-refresh refresh",
    class: {
      spin: _vm.refreshing
    },
    on: {
      "click": function($event) {
        !_vm.refreshing && _vm.requestStats(true)
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.initialized) ? _c('el-popover', {
    ref: "campaignSummary",
    attrs: {
      "placement": "bottom",
      "title": "Campaign Summary",
      "trigger": "click",
      "popper-class": "campaign-summary"
    },
    model: {
      value: (_vm.campaignSummaryVisible),
      callback: function($$v) {
        _vm.campaignSummaryVisible = $$v
      },
      expression: "campaignSummaryVisible"
    }
  }, [_c('campaign-summary', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (function () { return _vm.campaignSummaryVisible && _vm.window.setTimeout(function () { return _vm.campaignSummaryVisible = false; }, 0); }),
      expression: "() => campaignSummaryVisible && window.setTimeout(() => campaignSummaryVisible = false, 0)"
    }],
    attrs: {
      "campaign": this.item.id
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.initialized) ? _c('i', {
    directives: [{
      name: "popover",
      rawName: "v-popover:campaignSummary",
      arg: "campaignSummary"
    }],
    staticClass: "el-icon-share share"
  }) : _vm._e()], 1) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "slidein touch-scroll"
  }, [_c('div', {
    key: _vm.item && _vm.item.id,
    staticClass: "data-content content"
  }, [_c('div', {
    staticClass: "campaign-headers"
  }, [(_vm.item) ? _c('h1', [_vm._v(_vm._s(_vm.item.step1_campaign_name || _vm.item.step2_campaign_name))]) : _vm._e(), _vm._v(" "), (_vm.item && _vm.item.step1_campaign_name && _vm.item.step2_campaign_name) ? _c('h2', [_vm._v(_vm._s(_vm.item.step2_campaign_name))]) : _vm._e()]), _vm._v(" "), (_vm.initialized) ? _c('div', {
    staticClass: "affiliate-id"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.affiliateId) ? _c('h1', {
    key: "all"
  }, [_vm._v(_vm._s(_vm.affiliateId || 'All Affiliates'))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.loading || !_vm.initialized || _vm.message) ? _c('div', {
    key: "message",
    staticClass: "message",
    class: {
      loading: _vm.loading
    }
  }, [(_vm.message) ? _c('p', [_vm._v(_vm._s(_vm.message))]) : (_vm.loading || !_vm.initialized) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }]
  }) : _vm._e()]) : _c('div', {
    key: "content",
    staticClass: "performance-charts"
  }, [(!_vm.validCredentials) ? _c('el-alert', {
    staticClass: "error-bar",
    attrs: {
      "title": "This integration currently has known issues, and the stats may be incorrect or delayed.",
      "type": "error"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lastUpdated) ? _c('el-alert', {
    staticClass: "error-bar",
    attrs: {
      "title": _vm.lastUpdated,
      "type": "warning"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasStats && (_vm.step1Stats.length > 1 || _vm.step2Stats.length > 1)) ? _c('el-collapse', {
    ref: "rotator-collapse",
    model: {
      value: (_vm.activeTabs),
      callback: function($$v) {
        _vm.activeTabs = $$v
      },
      expression: "activeTabs"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "Performance Graph",
      "name": "1"
    }
  }, [_c('el-select', {
    staticClass: "chart-title",
    attrs: {
      "value": _vm.activeCampaignProps[_vm.currentDataView].label,
      "placeholder": "Select Data"
    },
    on: {
      "change": function (newVar) {
        _vm.currentDataView = newVar
      }
    }
  }, _vm._l((_vm.activeCampaignProps), function(config, prop) {
    return (!config.graphHidden) ? _c('el-option', {
      key: prop,
      attrs: {
        "value": prop,
        "label": config.label
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "chart-container",
    staticStyle: {
      "height": "400px",
      "width": "100%"
    }
  }, [_c('line-chart', {
    attrs: {
      "upper-bound": _vm.allStats.variance.max,
      "lower-bound": _vm.allStats.variance.min,
      "chart-data": _vm.graphData
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeCampaignProps), function(config, prop) {
    return _c('el-popover', {
      key: prop,
      ref: 'stat-popover-' + prop,
      refInFor: true,
      staticClass: "stat-popover",
      attrs: {
        "placement": "top-start",
        "open-delay": 150
      }
    }, [_c('div', {
      staticClass: "stat-definition"
    }, [_c('h1', {
      staticClass: "stat-popover__title"
    }, [_vm._v(_vm._s(config.label))]), _vm._v(" "), _c('span', {
      staticClass: "stat-definition--content"
    }, [_vm._v(_vm._s(config.def))])]), _vm._v(" "), (_vm.attributeLegend[prop]) ? _c('div', {
      staticClass: "stat-legend"
    }, [_c('h1', {
      staticClass: "stat-popover__title stat-legend__title"
    }, [_vm._v("Legend")]), _vm._v(" "), _c('ul', _vm._l((_vm.attributeLegend[prop]), function(value, index) {
      return _c('li', {
        key: index,
        staticClass: "stat-legend__li"
      }, [(index < _vm.attributeLegend[prop].length - 2) ? [_c('div', {
        staticClass: "stat-legend__square",
        class: _vm.colorCell(prop, _vm.attributeLegend[prop][index + 1].value)
      }), _vm._v("\n                    " + _vm._s(Math.round(value.value)) + " - " + _vm._s(Math.round(_vm.attributeLegend[prop][index + 1].value)) + " %\n                  ")] : (index == _vm.attributeLegend[prop].length - 2) ? [_c('div', {
        staticClass: "stat-legend__square",
        class: _vm.colorCell(prop, _vm.attributeLegend[prop][index + 1].value)
      }), _vm._v("\n                    > " + _vm._s(Math.round(value.value)) + " %\n                  ")] : _vm._e()], 2)
    }))]) : _vm._e()])
  }), _vm._v(" "), _vm._l(([_vm.step1Stats, _vm.step2Stats]), function(stats, stepIndex) {
    return (stats.length > 0 && _vm.dates[0]) ? _c('div', {
      key: stepIndex,
      staticClass: "campaign-table-wrapper",
      on: {
        "scroll": function($event) {
          $event.stopPropagation();
          _vm.stickyCell($event)
        },
        "touchmove": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('div', {
      staticClass: "campaign-table-scroller",
      on: {
        "scroll": _vm.stickyCell
      }
    }, [_c('table', {
      staticClass: "campaign-table"
    }, [_c('tbody', _vm._l((stats), function(row, key) {
      return _c('tr', {
        key: key
      }, _vm._l((_vm.activeCampaignProps), function(stat, prop) {
        return (stat.only == undefined || stat.only == stepIndex) ? _c('td', {
          key: prop,
          class: _vm.colorCell(prop, row[prop])
        }, [_c('span', [_vm._v(" " + _vm._s(row[prop]))])]) : _vm._e()
      }))
    })), _vm._v(" "), _c('thead', [_c('tr', _vm._l((_vm.activeCampaignProps), function(stat, prop) {
      return (stat.only == undefined || stat.only == stepIndex) ? _c('th', {
        key: prop,
        ref: 'stat-header-' + prop,
        refInFor: true,
        on: {
          "mouseenter": function (ev) { return _vm.showStatLegend(ev, stepIndex, prop); },
          "mouseleave": function (ev) { return _vm.hideStatLegend(ev, stepIndex, prop); }
        }
      }, [_vm._v("\n                      " + _vm._s(prop == 'date' ? 'Step ' + (stepIndex + 1) : stat.label) + "\n                    ")]) : _vm._e()
    }))])])])]) : _vm._e()
  })], 2)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a86f7d62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign.vue
// module id = wGSx
// module chunks = 1